import { useState } from "react";
import { Box, Typography } from "@mui/material";
import ScreenContainer from "../../Components/ScreenContainer";
import ClientApiManagementContent from "../../PagesContent/OrgSettings/ClientApiManagement/ClientApiManagementContent";

const ClientApiManagement = () => {
  const [pagesContent] = useState({ mounted: true });

  return (
    <ScreenContainer pagesContent={pagesContent}>
      <Box
        sx={{
          position: "sticky",
          top: "50px",
          zIndex: 1000,
          backgroundColor: "#FAFAFA",
        }}
      >
        <Box sx={{ px: 3, pt: 2, pb: 1 }}>
          <Typography variant="fw700s20lh24c2E2E2E">Client API Management</Typography>
          <Typography sx={{ fontSize: 13, color: "#888", mt: 0.5 }}>
            List of active and available client APIs
          </Typography>
        </Box>
      </Box>
      <Box sx={{ px: 3, pb: 3, pt: 2 }}>
        <ClientApiManagementContent />
      </Box>
    </ScreenContainer>
  );
};

export default ClientApiManagement;
